import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { calendarPtBrConfig } from 'src/app/shared/utils';

export interface ModalInputOption {
  title?: string;
  placeholder?: string;
  value?: string | Date | string[];
  data?: any;
  cls?: string;
  type?: 'text' | 'date' | 'datetime' | 'dates' | 'texts';
}

@Component({
  selector: 'app-modal-input',
  templateUrl: './modal-input.component.html',
  styleUrls: ['./modal-input.component.css']
})
export class ModalInputComponent {
  private resolve: any;
  private reject: any;

  public option: ModalInputOption = { placeholder: 'Nome', value: '' };
  public calendarPtBr: any;
  public selectedValue: any;

  constructor(
    public bsModalRef: BsModalRef
  ) {
    this.calendarPtBr = calendarPtBrConfig;
  }

  public setOption(resolve: any, reject: any, option: ModalInputOption = {}): void {
    this.resolve = resolve;
    this.reject = reject;
    this.option = Object.assign({ placeholder: 'Nome', value: option.value }, option);
    this.selectedValue = this.option.value;
  }

  public done(event) {
    this.resolve({ value: this.selectedValue, data: this.option.data });
    this.bsModalRef.hide();
  }

  public valid(): boolean {
    return this.selectedValue && this.selectedValue !== '';
  }

  setDate(value): void {
    this.selectedValue = value;
  }
}
